function isNumber(value) {
  return typeof value === 'number' && !Number.isNaN(value);
}
function isFunction(value) {
  return typeof value === 'function';
}

/**
 * Returns true if the arrays are equal. Elements will be shallowly compared by
 * default, or they will be compared using the custom `compare` function if one
 * is provided.
 */
function arraysEqual(arrA, arrB, compare = (a, b) => a === b) {
  // treat `null` and `undefined` as the same
  if (arrA == null && arrB == null) {
    return true;
  }
  if (arrA == null || arrB == null || arrA.length !== arrB.length) {
    return false;
  }
  return arrA.every((a, i) => compare(a, arrB[i]));
}
function isAllowlist(keys) {
  return keys != null && keys.include != null;
}
function isDenylist(keys) {
  return keys != null && keys.exclude != null;
}
function arrayToObject(arr) {
  return arr.reduce((obj, element) => {
    obj[element] = true;
    return obj;
  }, {});
}
function filterKeys(objA, objB, keys) {
  if (isAllowlist(keys)) {
    return keys.include;
  }
  if (isDenylist(keys)) {
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);

    // merge keys from both objects into a big set for quick access
    const keySet = arrayToObject(keysA.concat(keysB));

    // delete denied keys from the key set
    keys.exclude.forEach(key => delete keySet[key]);

    // return the remaining keys as an array
    return Object.keys(keySet);
  }
  return [];
}

/**
 * Partial shallow comparison between objects using the given list of keys.
 */
function shallowCompareKeysImpl(objA, objB, keys) {
  return filterKeys(objA, objB, keys).every(key => Object.prototype.hasOwnProperty.call(objA, key) === Object.prototype.hasOwnProperty.call(objB, key) && objA[key] === objB[key]);
}

/**
 * Shallow comparison between objects. If `keys` is provided, just that subset
 * of keys will be compared; otherwise, all keys will be compared.
 *
 * @returns true if items are equal.
 */
function shallowCompareKeys(objA, objB, keys) {
  // treat `null` and `undefined` as the same
  if (objA == null && objB == null) {
    return true;
  }
  if (objA == null || objB == null) {
    return false;
  }
  if (Array.isArray(objA) || Array.isArray(objB)) {
    return false;
  }
  if (keys != null) {
    return shallowCompareKeysImpl(objA, objB, keys);
  }
  // shallowly compare all keys from both objects
  const keysA = Object.keys(objA);
  const keysB = Object.keys(objB);
  return shallowCompareKeysImpl(objA, objB, {
    include: keysA
  }) && shallowCompareKeysImpl(objA, objB, {
    include: keysB
  });
}

export { arraysEqual, isFunction, isNumber, shallowCompareKeys };
